import { marked } from "marked";
import DOMPurify from "dompurify";
import markedCodePreview from "marked-code-preview";

export function markdownToSafeHtml(markdown: string): string {
  const html = marked.use(markedCodePreview()).parse(markdown ?? "", {
    gfm: true,
    breaks: true,
    async: false,
  }) as string;
  return DOMPurify.sanitize(html);
}
